import { getApiBaseUrl } from '../../utils/environment.mjs';
// src/services/baseApiService.mjs
import axios from 'axios';
import { secureLogger } from '../../utils/secureLogger.mjs';

class BaseApiService {
  constructor() {
    this.API_URL = getApiBaseUrl()
    this.api = axios.create({
      baseURL: this.API_URL,
      withCredentials: true, // This automatically sends cookies
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // Add request interceptor for logging
    this.api.interceptors.request.use(
      (config) => {
        secureLogger.apiRequest(config.method || 'GET', config.url);
        return config;
      },
      (error) => {
        secureLogger.error('Request interceptor error', { message: error.message });
        return Promise.reject(error);
      }
    );

    // Add response interceptor for error handling
    this.api.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response?.status === 401) {
          secureLogger.warn('Unauthorized access detected');
        }
        return Promise.reject(error);
      }
    );
  }
}

export default BaseApiService;


